import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';

const DebouncedInput = ({ className, validateOnBlur, onChange, placeholder, type = 'text', value, delay = 500 }) => {
  const [inputValue, setInputValue] = useState(value);

  const normalizeValue = (rawValue) => onChange(type === 'number' && isFinite(rawValue) ? Number(rawValue) : rawValue);

  const debouncedChange = useRef(
    debounce((newValue, oldValue) => {
      if (newValue !== oldValue) {
        normalizeValue(newValue);
      }
    }, delay)
  );

  const handleOnChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    if (!validateOnBlur) {
      debouncedChange.current(newValue, value);
    }
  };

  const handleBlur = (e) => {
    const newValue = e.target.value;

    if (newValue !== value) {
      normalizeValue(newValue);
    }
  };

  return (
    <input
      className={className}
      onChange={handleOnChange}
      placeholder={placeholder}
      type={type}
      value={inputValue}
      {...(validateOnBlur && { onBlur: handleBlur })}
    />
  );
};

DebouncedInput.propTypes = {
  className: PropTypes.string,
  delay: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['email', 'number', 'password', 'tel', 'text', 'url']).isRequired,
  validateOnBlur: PropTypes.bool,
};

export default DebouncedInput;
